import { NotificationAction } from '../types/NotificationAction';
import NotificationBody from '../types/NotificationBody';
import _ from 'lodash';

interface NotificationState {
	list: NotificationBody[],
	count: number,
};

const initialState: NotificationState = {
	list: [],
	count: 0,
};

const notificationReducers = (state = initialState, action: NotificationAction) => {
	switch (action.type) {
		case 'GET_NOTIFICATION_LIST': {
			let { list } = state;
			let data = action.data ? action.data : [];
			let newList = [...list,...data];
			return { ...state, list: newList }
		}
		case 'GET_NOTIFICATION_COUNT': {
			return { ...state, count: action.data }
		}
		case 'CLEAR_NOTIFICATION': {
			return { ...state, list: [] }
		}
		default:
			return state;
	}
}


export default notificationReducers;